export const generateYearWithNRIC = (nric) => {
  // this function work only for the people born in 1968 and after
  // first character S and T for Sg , F and G for foreigner
  // first two digit of nric reflect to last two digits of birth year.
  // But it only applies to Singapore citizens and PRs born in the year 1968 and after.
  // For those born before 1968, their NRIC number will begin with a 0 or 1
  if (nric.length === 9) {
    //https://sg.theasianparent.com/singapore-nric-number-surprising-facts
    let prefix = nric.substring(0, 1);
    // f

    let year = nric.substring(1, 3);

    if (!parseInt(year)) {
      // Nan
      return ["E"];
    }

    let first_year = parseInt(nric.substring(1, 3), 10);

    console.log(prefix, year);
    if (prefix === "S") {
      // citizen born before 2000

      let current_year = new Date().getFullYear();

      if (first_year < 68) {
        // people born before 1968

        return ["S", current_year - 1968, ">"];
      } else {
        let birth_year = parseInt("19" + year, 10);
        const _age = current_year - birth_year;
        return ["S", _age, _age === 0 ? "<" : "="];
      }
    } else if (prefix === "T") {
      // citizen born after 2020
      let current_year = new Date().getFullYear();
      console.log(current_year);

      let birth_year = parseInt("20" + year, 10);
      console.log(birth_year);
      const _age = current_year - birth_year;
      return ["S", _age, _age === 0 ? "<" : "="];
    } else {
      return ["E"]; // F & G
    }
  } else {
    return ["E"];
  }
};

const MIN_PASSPORT_LENGTH = 4;

export const validateNRIC = (str) => {
  if (str.length != 9) return false;

  str = str.toUpperCase();

  var i,
    icArray = [];
  for (i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] = parseInt(icArray[1], 10) * 2;
  icArray[2] = parseInt(icArray[2], 10) * 7;
  icArray[3] = parseInt(icArray[3], 10) * 6;
  icArray[4] = parseInt(icArray[4], 10) * 5;
  icArray[5] = parseInt(icArray[5], 10) * 4;
  icArray[6] = parseInt(icArray[6], 10) * 3;
  icArray[7] = parseInt(icArray[7], 10) * 2;

  var weight = 0;
  for (i = 1; i < 8; i++) {
    weight += icArray[i];
  }

  var offset = icArray[0] === "T" || icArray[0] === "G" ? 4 : 0;
  var offset = icArray[0] === "M" ? 3 : offset;
  var temp = (offset + weight) % 11;

  var st = ["J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"];
  var fg = ["X", "W", "U", "T", "R", "Q", "P", "N", "M", "L", "K"];
  var m = ["K", "L", "J", "N", "P", "Q", "R", "T", "U", "W", "X"];

  var theAlpha;
  if (icArray[0] === "S" || icArray[0] === "T") {
    theAlpha = st[temp];
  } else if (icArray[0] === "F" || icArray[0] === "G") {
    theAlpha = fg[temp];
  } else if (icArray[0] === "M") {
    const mIndex = 10 - temp;
    theAlpha = m[mIndex];
  }

  return icArray[8] === theAlpha;
};

export const validatePassportAndNRIC = (val) => {
  const _val = val.trim().toUpperCase();

  const match = _val.match(/^[S|T|F|G|M][0-9]{7}[A-Z]$/gm);
  if (match === null && _val.length >= MIN_PASSPORT_LENGTH) {
    // Passport
    return true;
  }
  if (match !== null) {
    return validateNRIC(val);
  }
};
